export enum OrganizationRole {
  OwnerShareholder = 1,
  Director = 2,
  Employee = 4,
  Other = 5
}

// tslint:disable-next-line:no-namespace
export namespace OrganizationRole {
  export function toString(role: OrganizationRole): string {
    switch (role) {
      case OrganizationRole.OwnerShareholder:
        return 'Owner Shareholder';
      case OrganizationRole.Director:
        return 'Director';
      case OrganizationRole.Employee:
        return 'Employee';
      case OrganizationRole.Other:
        return 'Other';
      default:
        return null;
    }
  }

  export function parse(roleStr: string): OrganizationRole {
    return OrganizationRole[roleStr];
  }

  export function listAll() {
    return [OrganizationRole.OwnerShareholder, OrganizationRole.Director, OrganizationRole.Employee, OrganizationRole.Other];
  }
}

export default OrganizationRole;
